/* src/app/forms/produtos/mercadolivre/meli-item/variation-meli-popup/variation-meli-popup.component.scss */
.content {
  height: 100%;
  padding: 16px;
  max-height: 50vh;
  overflow: auto;
  width: 100%;
}
.detail {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
}
.detail-item {
  flex: 0 0 calc(25% - 12px);
  max-width: calc(25% - 12px);
}
@media (max-width: 599px) {
  .detail-item {
    flex-basis: 100%;
    max-width: 100%;
  }
}
.dialog-title {
  padding: 16px;
  margin: 0;
  font-size: var(--tem-fs-lg, 18px);
  font-weight: 600;
}
.finish {
  padding: 16px;
  display: flex;
  width: 100%;
}
.finish button {
  width: 100%;
  font-size: 0.8vw;
}
/*# sourceMappingURL=variation-meli-popup.component.css.map */
